import { useI18n } from "@/lib/i18n";

export default function LanguageToggle() {
  const { lang, setLang } = useI18n();
  return (
    <div data-testid="lang-toggle"
      className="flex items-center rounded-full border border-zinc-700 overflow-hidden">
      {["id", "en"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
          className={`px-2.5 py-1 font-mono-ui text-[10px] uppercase tracking-wider transition-colors ${
            lang === l ? "bg-[#d4af37] text-zinc-950" : "text-zinc-400 hover:text-zinc-100"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
